// @flow
export const filterId: 'employee' = 'employee';
